import { useRef } from 'react';
import BasesInfiniteList from './basesInfiniteList';
import FilterListBases from '../utils/filterLists/filterListBases';
import ListPageLayout from '../utils/ListPageLayout';

function BasesPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Bases"
        tagline="Airfields used by the Eighth Air Force for training and operations in the US and UK."
        sidebar={<FilterListBases isFiltered={handleQuery} />}
      >
        <BasesInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default BasesPage;
